import * as React from "react";
import { useMemo } from "react";
import { BaseModal } from "../../../../atoms/base-modal";
import classNames from "classnames";
import { matchType } from "../../../../../application/domain/base/base-type";
import { formatAmount, Payment } from "@graffer-inc/cloud-gov-core";
export type AdjustmentModalProps = {
  targetPayment: Payment;
  isSubmitting: boolean;
  onClose: () => void;
  onResolve: () => void;
};
export const AdjustmentModal: React.FC<AdjustmentModalProps> = ({
  targetPayment,
  isSubmitting,
  onClose,
  onResolve,
}) => {
  const invoiceAmount = useMemo(() => {
    return targetPayment.invoice.items.reduce(function (sum, element) {
      return sum + element.amount;
    }, 0);
  }, [targetPayment]);
  const adjustmentAmounts = useMemo(() => {
    const invoice = targetPayment.invoice.items.reduce(function (sum, element) {
      return sum + element.amount;
    }, 0);
    const charged = targetPayment.amountCharged;
    const adjust = Math.abs(invoiceAmount - charged);
    return { invoice, charged, adjust };
  }, [targetPayment]);

  return (
    <BaseModal
      title={matchType(targetPayment.status, {
        exceeding_payment: "過入金の解消",
        deficient_payment: "入金不足の解消",
      })}
      isActive={true}
      onClose={onClose}
    >
      <section className="modal-card-body">
        <p>
          {matchType(targetPayment.status, {
            exceeding_payment: "システム外の返金",
            deficient_payment: "システム外の入金",
          })}
          を登録し、
          {matchType(targetPayment.status, {
            exceeding_payment: "過入金",
            deficient_payment: "入金不足",
          })}
          を解消します。よろしいですか？
        </p>
        <p className="has-text-weight-normal">
          ※ 解消額は決済データに反映されません。
        </p>
        <div className="field container mt-5">
          <table className="table  c-border" style={{ margin: "auto" }}>
            <tbody>
              <tr>
                <td className="has-text-right">依頼金額</td>
                <td className="has-text-left">
                  {formatAmount(adjustmentAmounts.invoice) + "円"}
                </td>
              </tr>
              <tr>
                <td className="has-text-right">総支払額</td>
                <td className="has-text-left">
                  {formatAmount(adjustmentAmounts.charged) + "円"}
                </td>
              </tr>
              <tr>
                <td className="has-text-right">解消額</td>
                <td className="has-text-left">
                  {formatAmount(adjustmentAmounts.adjust) + "円"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="modal-card-foot">
        <button className="button is-fullwidth" onClick={onClose}>
          閉じる
        </button>
        <button
          className={classNames("button is-fullwidth is-info", {
            "is-loading": isSubmitting,
          })}
          onClick={() => onResolve()}
        >
          差額を解消する
        </button>
      </section>
    </BaseModal>
  );
};
